import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import html2canvas from 'html2canvas';
import jspdf from 'jspdf';

@Component({
  selector: 'app-instructions',
  imports: [CommonModule],
  templateUrl: './instructions.component.html',
  styleUrl: './instructions.component.css',
  standalone: true
})
export class InstructionsComponent  implements OnInit {

  @Input() name: any;
public instructiontext : string = "";
primaryColor?: string = "";
  constructor(public activeModal: NgbActiveModal) {}
  
  ngOnInit(): void {
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  exportAsPDF(divId: any) {
    let data: any = document.getElementById(divId);
    if (!data) {
      console.error('Element not found for PDF export');
      return;
    }

    html2canvas(data, {
      scale: 2, // Higher quality
      useCORS: true,
      allowTaint: false
    }).then(canvas => {
      const contentDataURL = canvas.toDataURL('image/png');
      
      // Calculate dimensions
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      
      // PDF dimensions in mm (A4 portrait: 210 x 297)
      const pdfWidth = 210;
      const pdfHeight = 297;
      const margin = 10;
      const maxWidth = pdfWidth - (margin * 2);
      const maxHeight = pdfHeight - (margin * 2);
      
      // Calculate scaling to fit content within PDF
      const widthRatio = maxWidth / (imgWidth * 0.264583); // Convert px to mm
      const heightRatio = maxHeight / (imgHeight * 0.264583);
      const scale = Math.min(widthRatio, heightRatio, 1); // Don't scale up
      
      const scaledWidth = (imgWidth * 0.264583) * scale;
      const scaledHeight = (imgHeight * 0.264583) * scale;
      
      // Center the content
      const xPosition = margin + (maxWidth - scaledWidth) / 2;
      const yPosition = margin;
      
      let pdf = new jspdf('l', 'mm', 'a4'); // Portrait mode
      pdf.addImage(contentDataURL, 'PNG', xPosition, yPosition, scaledWidth, scaledHeight);
      pdf.save('Instructions.pdf');
    }).catch(error => {
      console.error('Error generating PDF:', error);
    });
  }

}
